<template>
  <div id="analyze-detail">
  <div class="container mt-3">
    <div class="row">
      <div class="col-12">
        <b-button class="title-font float-right" variant="outline-secondary" size="sm"
          @click="resetConf(false);">normal</b-button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <counter :info="info" />
      </div>
    </div>
    <div v-if="isGameProg" class="row mt-5">
      <div class="col-12">
        <HitsTable :hits="hits" :isHeader="true"
        :label="rallyCount - 1" :gameInfo="game.gameInfo" />
      </div>
    </div>
    <div class="container mw-600 mt-5">
    <div class="row" v-if="game.gameInfo.firstGameServer == 0">
      <div class="col-12 pa-2">
        サーバーを選択してください
      </div>
      <div class="col-6 pa-2">
        <b-button class="btn-dblue"
          @click="addGameInfo({ key: 'firstGameServer', value: 1 });">
          {{ game.gameInfo.player1Name }}
        </b-button>
      </div>
      <div class="col-6 pa-2">
        <b-button class="btn-dgreen"
          @click="addGameInfo({ key: 'firstGameServer', value: 2 });">
          {{ game.gameInfo.player2Name }}
        </b-button>
      </div>
    </div>
    <div v-else>
      <transition name="slide-fade" mode="out-in">
        <!-- player1 serve -->
        <div v-if="clickCount === displayButtons.player1Hits && clickCount == 1" key="serve1">
          <div class="text-left">サーブの種類</div>
          <div class="row">
            <div v-for="(serve, idx) in CmnConst.serveList" class="col-6 pa-2" :key="idx">
              <b-button class="btn-dblue pa-2"
                :disabled="hit.hand == null"
                @click="clickCount += 1;hit.hitStyle = idx">{{ serve }}</b-button>
            </div>
            <div class="col-12 pa-2">
              <b-button variant="outline-secondary"
                :disabled="!(clickCount === displayButtons.player1Hits && clickCount == 1)"
                class="btn-option" @click="clickCount -= 1">
                <font-awesome-icon icon="backspace" />
              </b-button>
            </div>
          </div>
        </div>
        <!-- player2 serve -->
        <div v-else-if="clickCount === displayButtons.player2Hits && clickCount == 1" key="serve2">
          <div class="text-left">サーブの種類</div>
          <div class="row">
            <div v-for="(serve, idx) in CmnConst.serveList" class="col-6 pa-2" :key="idx">
              <b-button class="btn-dgreen pa-2"
               :disabled="hit.hand == null"
                @click="clickCount += 1;hit.hitStyle = idx">{{ serve }}</b-button>
            </div>
            <div class="col-12 pa-2">
              <b-button variant="outline-secondary"
                :disabled="!(clickCount === displayButtons.player2Hits && clickCount == 1)"
                class="btn-option" @click="clickCount -= 1">
                <font-awesome-icon icon="backspace" />
              </b-button>
            </div>
          </div>
        </div>
        <!-- player1 -->
        <div v-else-if="clickCount % 8 == displayButtons.player1ForeOrBack" key="1">
          <div class="row">
            <!-- サーブ -->
            <div v-if="clickCount === 0" class="mt-3 col-12 text-center">
              <div class="text-left">サーブ打球位置</div>
              <b-form-group class="mt-2">
                <b-form-radio-group v-model="hit.hitPosition"
                  name="hit-postion-radios" :options="CmnConst.hitPostionAtServeOption"
                  :disabled="!isGameProg && !(clickCount % 8 == displayButtons.player1ForeOrBack)"/>
              </b-form-group>
            </div>
            <!-- サーブ以外 -->
            <div v-else class="mt-3 col-12 text-center">
              <div class="text-left">打球位置</div>
              <b-form-group class="mt-2">
                <b-form-radio-group v-model="hit.hitPosition"
                  :disabled="!(clickCount % 8 == displayButtons.player1ForeOrBack)"
                  name="hit-postion-radios" :options="CmnConst.hitPostionOption" />
              </b-form-group>
            </div>
            <div class="col-6 pa-2">
              <b-button class="btn-dblue" @click="clickCount += 1;hit.hand = 1;"
                :disabled="!isGameProg && hit.hand != null
                  && hit.course != null && hit.hitStyle != null">
                バックハンド
              </b-button>
            </div>
            <div class="col-6 pa-2">
              <b-button class="btn-dblue" @click="clickCount += 1;hit.hand = 0;"
                :disabled="!isGameProg && hit.hand != null
                  && hit.course != null && hit.hitStyle != null">
                フォアハンド
              </b-button>
            </div>
            <div class="col-12 pa-2">
              <b-button variant="outline-secondary"
                :disabled="!(clickCount % 8 == displayButtons.player1ForeOrBack)"
                class="btn-option" @click="back();">
                <font-awesome-icon icon="backspace" />
              </b-button>
            </div>
          </div>
        </div>
        <div v-else-if="clickCount % 8 == displayButtons.player1Hits" key="2">
          <div class="text-left">打法</div>
          <div class="row">
            <div v-for="(hitsStyle, idx) in CmnConst.hitsStyleList" class="col-6 pa-2" :key="idx">
              <b-button class="btn-dblue pa-1"
                :disabled="hit.hand == null"
                @click="clickCount += 1;hit.hitStyle = idx">{{ hitsStyle }}</b-button>
            </div>
            <div class="col-12 pa-2">
              <b-button variant="outline-secondary"
                :disabled="!(clickCount % 8 == displayButtons.player1Hits)"
                class="btn-option" @click="clickCount -= 1;">
                <font-awesome-icon icon="backspace" />
              </b-button>
            </div>
          </div>
        </div>
        <div v-else-if="clickCount % 8 == displayButtons.player1Course" key="3">
          <div class="text-left">コース</div>
          <div class="row">
            <div v-for="(course, idx) in CmnConst.courseList" class="col-6 pa-2" :key="idx">
              <b-button class="btn-dblue"
                :disabled="hit.hand == null || hit.hitStyle == null"
                @click="clickCount += 1;hit.course = idx;">{{ course }}</b-button>
            </div>
            <div class="col-12 pa-2">
              <b-button variant="outline-secondary"
                :disabled="!(clickCount % 8 == displayButtons.player1Course)"
                class="btn-option" @click="clickCount -= 1;">
                <font-awesome-icon icon="backspace" />
              </b-button>
            </div>
          </div>
        </div>
        <div v-else-if="clickCount % 8 == displayButtons.player1InOrOut" key="4">
          <div class="text-left">イン</div>
          <div class="row">
            <div v-for="(inObj, idx) in CmnConst.inList" class="col-6 pa-2" :key="idx">
              <b-button class="btn-dblue"
                :disabled="hit.hand == null || hit.hitStyle == null || hit.course == null"
                @click="nextHit(idx, 1)">
                {{ inObj }}
              </b-button>
            </div>
          </div>
          <div class="text-left">アウト</div>
          <div class="row">
            <div v-for="(out, idx) in CmnConst.outList" class="col-6 pa-2" :key="idx">
              <b-button variant=danger class="btn-option"
                :disabled="hit.hand == null || hit.hitStyle == null || hit.course == null"
                @click="nextPoint(idx, 0)">
                {{ out }}
              </b-button>
            </div>
            <div class="col-12 pa-2">
              <b-button variant="outline-secondary"
                :disabled="!(clickCount % 8 == displayButtons.player1InOrOut)"
                class="btn-option" @click="clickCount -= 1;">
                <font-awesome-icon icon="backspace" />
              </b-button>
            </div>
          </div>
        </div>
        <!-- player2 -->
        <div v-else-if="clickCount % 8 == displayButtons.player2ForeOrBack" key="5">
          <div class="row">
            <!-- サーブ -->
            <div v-if="clickCount === 0" class="mt-3 col-12 text-center">
              <div class="text-left">サーブ打球位置</div>
              <b-form-group class="mt-2">
                <b-form-radio-group v-model="hit.hitPosition"
                  name="hit-postion-radios" :options="CmnConst.hitPostionAtServeOption"
                  :disabled="!isGameProg && !(clickCount % 8 == displayButtons.player2ForeOrBack)"/>
              </b-form-group>
            </div>
            <!-- サーブ以外 -->
            <div v-else class="mt-3 col-12 text-center">
              <div class="text-left">打球位置</div>
              <b-form-group class="mt-2">
                <b-form-radio-group v-model="hit.hitPosition"
                  :disabled="!(clickCount % 8 == displayButtons.player2ForeOrBack)"
                  name="hit-postion-radios" :options="CmnConst.hitPostionOption" />
              </b-form-group>
            </div>
            <div class="col-6 pa-2">
              <b-button class="btn-dgreen" @click="clickCount += 1;hit.hand = 1;"
                :disabled="!isGameProg && hit.hand != null
                && hit.course != null && hit.hitStyle != null">
                バックハンド
              </b-button>
            </div>
            <div class="col-6 pa-2">
              <b-button class="btn-dgreen" @click="clickCount += 1;hit.hand = 0;"
                :disabled="!isGameProg && hit.hand != null
                && hit.course != null && hit.hitStyle != null">
                フォアハンド
              </b-button>
            </div>
            <div class="col-12 pa-2">
              <b-button variant="outline-secondary"
                :disabled="!(clickCount % 8 == displayButtons.player2ForeOrBack)"
                class="btn-option" @click="back();">
                <font-awesome-icon icon="backspace" />
              </b-button>
            </div>
          </div>
        </div>
        <div v-else-if="clickCount % 8 == displayButtons.player2Hits" key="6">
          <div class="text-left">打法</div>
          <div class="row">
            <div v-for="(hitsStyle, idx) in CmnConst.hitsStyleList" class="col-6 pa-2" :key="idx">
              <b-button class="btn-dgreen pa-1"
                :disabled="hit.hand == null"
                @click="clickCount += 1;hit.hitStyle = idx">{{ hitsStyle }}</b-button>
            </div>
            <div class="col-12 pa-2">
              <b-button variant="outline-secondary"
                :disabled="!(clickCount % 8 == displayButtons.player2Hits)"
                class="btn-option" @click="clickCount -= 1;">
                <font-awesome-icon icon="backspace" />
              </b-button>
            </div>
          </div>
        </div>
        <div v-else-if="clickCount % 8 == displayButtons.player2Course" key="7">
          <div class="text-left">コース</div>
          <div class="row">
            <div v-for="(course, idx) in CmnConst.courseList" class="col-6 pa-2" :key="idx">
              <b-button class="btn-dgreen"
                :disabled="hit.hand == null || hit.hitStyle == null"
                @click="clickCount += 1;hit.course = idx;">{{ course }}</b-button>
            </div>
            <div class="col-12 pa-2">
              <b-button variant="outline-secondary"
                :disabled="!(clickCount % 8 == displayButtons.player2Course)"
                class="btn-option" @click="clickCount -= 1;">
                <font-awesome-icon icon="backspace" />
              </b-button>
            </div>
          </div>
        </div>
        <div v-else-if="clickCount % 8 == displayButtons.player2InOrOut" key="8">
          <div class="text-left">イン</div>
          <div class="row">
            <div v-for="(inObj, idx) in CmnConst.inList" class="col-6 pa-2" :key="idx">
              <b-button class="btn-dgreen"
                :disabled="hit.hand == null || hit.hitStyle == null || hit.course == null"
                @click="nextHit(idx, 2)">
                {{ inObj }}
              </b-button>
            </div>
          </div>
          <div class="text-left">アウト</div>
          <div class="row">
            <div v-for="(out, idx) in CmnConst.outList" class="col-6 pa-2" :key="idx">
              <b-button variant=danger class="btn-option"
                :disabled="hit.hand == null || hit.hitStyle == null || hit.course == null"
                @click="nextPoint(idx, 1)">
                {{ out }}
              </b-button>
            </div>
            <div class="col-12 pa-2">
              <b-button variant="outline-secondary"
                :disabled="!(clickCount % 8 == displayButtons.player2InOrOut)"
                class="btn-option" @click="clickCount -= 1;">
                <font-awesome-icon icon="backspace" />
              </b-button>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="row mt-3">
      <div class="col-4 pa-2">
        <b-button variant="outline-secondary" class="btn-option" v-b-modal.modal-1>
          <font-awesome-icon icon="wrench"/>
        </b-button>
      </div>
      <div class="col-4 pa-2">
        <b-button variant="outline-secondary" class="btn-option" v-b-modal.modal-3>
          <font-awesome-icon icon="link"/>
        </b-button>
      </div>
      <div class="col-4 pa-2">
        <b-button variant="outline-secondary" class="btn-option" @click="resetConf(true);">
          <strong>C</strong>
        </b-button>
      </div>
    </div>
    <div v-if="game.gameInfo.memoFlg == 1" class="mb-4 mt-4">
      <b-form-textarea id="textarea" v-model="game.gameInfo.memo"
        placeholder="メモ" rows="5" max-rows="1000" />
    </div>
    <div class="mt-4 text-center">
      <div v-if="!user.signIn" class="text-muted">ログイン後データを保存できます</div>
      <b-button variant="primary" :disabled="!user.signIn"
        class="btn-block btn-lg" @click="submitData(true, true)" v-if="user.signIn && app.docId">
        更新する
        </b-button>
      <b-button variant="primary" :disabled="!user.signIn || submittingFlg"
        class="btn-block btn-lg" @click="submitData(true, true)" v-else>
        保存する
      </b-button>
    </div>
  </div>
    <!--モーダルの設定-->
    <b-modal id="modal-1" centered title="設定" hide-footer>
      <label>試合名</label>
      <b-form-input v-model="game.gameInfo.matchName">{{ game.gameInfo.matchName }}</b-form-input>
      <label class="mt-3">選手名</label>
      <b-form-input v-model="game.gameInfo.player1Name">
        {{ game.gameInfo.player1Name }}
      </b-form-input>
      <b-form-input v-model="game.gameInfo.player2Name">
        {{ game.gameInfo.player2Name }}
      </b-form-input>
      <label class="mt-3">利き手</label>
      <div>
        <div class="d-inline">{{ game.gameInfo.player1Name }}</div>
        <b-form-select class="d-inline w-75 ml-3"
          v-model="game.gameInfo.player1Hand" :options="handOptions"></b-form-select>
      </div>
      <div>
        <div class="d-inline">{{ game.gameInfo.player2Name }}</div>
        <b-form-select class="d-inline w-75 ml-3"
          v-model="game.gameInfo.player2Hand" :options="handOptions"></b-form-select>
      </div>
      <label class="mt-3">ゲーム数</label>
      <b-form-select v-model="game.gameInfo.matchCnt" :options="options"></b-form-select>
      <label class="mt-3">メモの保存</label>
      <b-form-checkbox v-model="game.gameInfo.memoFlg">保存する</b-form-checkbox>
      <div class="mt-3">
        <b-button variant="outline-secondary" class="btn-sm"
          @click="outputData()" v-if="user.signIn && this.app.docId">
          <font-awesome-icon icon="file-download" /> CSVダウンロード
        </b-button>
        <b-button variant="danger" class="btn-sm float-right"
          @click="deleteData()" v-if="user.signIn && this.app.docId">
          <font-awesome-icon icon="trash-alt" /> 削除する
        </b-button>
      </div>
    </b-modal>
    <!--モーダルの設定-->
    <b-modal id="modal-3" centered title="共有設定" hide-footer>
      <div class="mt-3" @click="publicShareFlgOnClick()">
        <b-form-checkbox v-model="game.gameInfo.linkShareFlg">
          リンクを知っている人に公開する
        </b-form-checkbox>
      </div>
      <div class="mt-3" @click="linkShareFlgOnClick()">
        <b-form-checkbox v-model="game.gameInfo.publicShareFlg">
          みんなの分析で公開する
        </b-form-checkbox>
      </div>
      <div class="mt-3">
        <b-form-checkbox v-model="game.gameInfo.isRealTime"
          :disabled="!(user.signIn && this.app.docId)">
          ライブ配信を有効にする
        </b-form-checkbox>
      </div>
    </b-modal>
    <!-- 打球編集用モーダル -->
    <b-modal id="modal-2" centered title="打球情報の編集" hide-footer>
    <div class="row">
    <div class="mt-1 col-12">
      プレイヤー:
      <span v-if="editHit.player == 1">{{ game.gameInfo.player1Name }}</span>
      <span v-else-if="editHit.player == 2">{{ game.gameInfo.player2Name }}</span>
    </div>
    <div class="mt-1 col-6">
      フォア・バック
      <b-form-select class="shadow-sm" v-model="editHit.hand"
        :options="foreBackList" size="sm" />
    </div>
    <div class="mt-1 col-6">
      コース
      <b-form-select class="shadow-sm" v-model="editHit.course"
        :options="courseList" size="sm" />
    </div>
    <div v-if="editHit.isServe" class="mt-1 col-6">
      サーブの種類
      <b-form-select class="shadow-sm" v-model="editHit.hitStyle"
        :options="hitsListOnServe" size="sm" />
    </div>
    <div v-else class="mt-1 col-6">
      打法
      <b-form-select class="shadow-sm" v-model="editHit.hitStyle"
        :options="hitsList" size="sm" />
    </div>
    <div v-if="editHit.isServe" class="mt-1 col-6">
      サーブ打球位置
      <b-form-select class="shadow-sm" v-model="editHit.hitPosition"
        :options="hitPositionListOnServe" size="sm" />
    </div>
    <div v-else class="mt-1 col-6">
      打球位置
      <b-form-select class="shadow-sm" v-model="editHit.hitPosition"
        :options="hitPositionList" size="sm" />
    </div>
    <div v-if="!editHit.inOut" class="mt-1 col-6">
      アウト詳細
      <b-form-select class="shadow-sm" v-model="editHit.inOutDetail"
        :options="outDetailList" size="sm" />
    </div>
    <div v-if="editHit.inOut && !editHit.isServe" class="mt-1 col-6">
      イン詳細
      <b-form-select class="shadow-sm" v-model="editHit.inOutDetail"
        :options="inDetailList" size="sm" />
    </div>
    </div>
    <div class="col-12 mt-3">
      <b-button variant="primary" class="btn-sm float-right"
        @click="updHitsOnClick(editHit);">
        保存
      </b-button>
    </div>
    </b-modal>
    <graph :game="game"  @edit="editHits"/>
    <div class="row mt-5">
      <div class="col-12 text-center">
        <b-button variant="outline-secondary" class="btn" @click="$router.push('/detail_data');">
          詳細データ
        </b-button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/firestore';
import counter from '@/components/molecules/Counter';
import Graph from '@/components/organisms/Graph';
import HitsTable from '@/components/molecules/HitsTable';
import func from '@/lib/func';
import CmnConst from '@/lib/cmnConst';
import makeCsv from '@/lib/makeCsv';

export default {
  name: 'analyze-detail',
  components: {
    counter,
    Graph,
    HitsTable,
  },
  data() {
    return {
      manualInput1: '',
      manualInput2: '',
      options: [
        { value: 1, text: '1ゲーム' },
        { value: 2, text: '3ゲーム（2ゲーム先取）' },
        { value: 3, text: '5ゲーム（3ゲーム先取）' },
        { value: 4, text: '7ゲーム（4ゲーム先取）' },
      ],
      handOptions: [
        { value: 0, text: '右' },
        { value: 1, text: '左' },
      ],
      manualName: '',
      intervalId: undefined,
      submittingFlg: false,
      clickCount: 0,
      hits: {
        hand: [],
        hitStyle: [],
        hitPosition: [],
        course: [],
        inOut: [],
        inOutDetail: [],
        player: [],
        isServe: [],
      },
      hit: {
        hand: null, // int 0:forehand, 1:backhand
        hitStyle: null, // int
        hitPosition: 0, // 0:前陣, 1:中陣, 2:後陣
        course: null, // int
        inOut: null, // boolean, true: In, false: Out
        inOutDetail: null, // int
        player: 0, // 1 or 2
        isServe: false, // true, false
      },
      CmnConst,
      editHit: {},
      editIdx: {},
    };
  },
  mounted() {
    this.intervalId = setInterval(() => {
      if (this.game.gameInfo.isRealTime) {
        this.submitData(false, true);
      }
    }, 15000);
  },
  destroyed() {
    clearInterval(this.intervalId);
  },
  computed: {
    info() {
      let info = { p1: 0, p2: 0, s1: 0, s2: 0, nextSv: 0 };
      for (let i = 0; i < this.game.points.length; i++) {
        info = func.nextPoint(info, this.game.points[i]);
      }
      if (this.game.gameInfo.firstGameServer !== 0) {
        info.nextSv = func.getNextServer(info, this.game.gameInfo.firstGameServer);
      }
      return info;
    },
    isGameProg() {
      // true: ゲーム途中, false: ゲーム終了
      if (this.info.s1 === this.game.gameInfo.matchCnt
        || this.info.s2 === this.game.gameInfo.matchCnt) {
        return false;
      }
      return true;
    },
    rallyCount() {
      return Math.floor(this.clickCount / 4);
    },
    displayButtons() {
      let player1Num = 0;
      let player2Num = 0;
      if (this.info.nextSv === 1) {
        player2Num = 4;
      } else if (this.info.nextSv === 2) {
        player1Num = 4;
      }
      return {
        player1ForeOrBack: 0 + player1Num,
        player1Hits: 1 + player1Num,
        player1Course: 2 + player1Num,
        player1InOrOut: 3 + player1Num,
        player2ForeOrBack: 0 + player2Num,
        player2Hits: 1 + player2Num,
        player2Course: 2 + player2Num,
        player2InOrOut: 3 + player2Num,
      };
    },
    foreBackList() {
      const options = [];
      for (let i = 0; i < CmnConst.handList.length; i++) {
        options.push({ value: i, text: CmnConst.handList[i] });
      }
      return options;
    },
    courseList() {
      const options = [];
      for (let i = 0; i < CmnConst.courseList.length; i++) {
        options.push({ value: i, text: CmnConst.courseList[i] });
      }
      return options;
    },
    hitsListOnServe() {
      const options = [];
      for (let i = 0; i < CmnConst.serveList.length; i++) {
        options.push({ value: i, text: CmnConst.serveList[i] });
      }
      return options;
    },
    hitsList() {
      const options = [];
      for (let i = 0; i < CmnConst.hitsStyleList.length; i++) {
        options.push({ value: i, text: CmnConst.hitsStyleList[i] });
      }
      return options;
    },
    hitPositionList() {
      const options = [];
      for (let i = 0; i < CmnConst.hitPostion.length; i++) {
        options.push({ value: i, text: CmnConst.hitPostion[i] });
      }
      return options;
    },
    hitPositionListOnServe() {
      const options = [];
      for (let i = 0; i < CmnConst.hitPostionAtServe.length; i++) {
        options.push({ value: i, text: CmnConst.hitPostionAtServe[i] });
      }
      return options;
    },
    inDetailList() {
      const options = [];
      for (let i = 0; i < CmnConst.inList.length; i++) {
        options.push({ value: i, text: CmnConst.inList[i] });
      }
      return options;
    },
    outDetailList() {
      const options = [];
      for (let i = 0; i < CmnConst.outList.length; i++) {
        options.push({ value: i, text: CmnConst.outList[i] });
      }
      return options;
    },
    ...mapGetters([
      'game',
      'user',
      'app',
    ]),
  },
  methods: {
    ...mapActions([
      'addPoint',
      'delPoint',
      'addGameInfo',
      'reset',
      'SignOut',
      'delGameData',
      'linkShareFlgOn',
      'publicShareFlgOn',
      'updHits',
      'storeIsLoading',
    ]),
    async firstoreUpdate(isDetailData) {
      const db = firebase.firestore();
      // ライブ配信時の動きを考慮して、打球情報から更新しにいく
      if (isDetailData) {
        const dbHitsList = Object.assign({}, this.game.hitsList);
        await db.collection('games').doc(this.app.docId).collection('option').doc('hitsList')
          .update(dbHitsList);
      }
      await db.collection('games').doc(this.app.docId)
        .update({
          points: this.game.points,
          labels: this.game.labels,
          manualLabels: this.game.manualLabels,
          gameInfo: this.game.gameInfo,
          status: this.game.status,
          updateDate: firebase.firestore.FieldValue.serverTimestamp(),
        });
    },
    async firestoreAdd() {
      const db = firebase.firestore();
      const doc = await db.collection('games').add({
        author: this.user.uid,
        points: this.game.points,
        labels: this.game.labels,
        manualLabels: this.game.manualLabels,
        gameInfo: this.game.gameInfo,
        status: this.game.status,
        isProMode: this.game.isProMode,
        createDate: firebase.firestore.FieldValue.serverTimestamp(),
        updateDate: firebase.firestore.FieldValue.serverTimestamp(),
      });
      const dbHitsList = Object.assign({}, this.game.hitsList);
      dbHitsList.parentDocId = doc.id;
      await db.collection('games').doc(doc.id).collection('option').doc('hitsList')
        .set(dbHitsList);
    },
    submitData(isToDataPage, isDetailData) {
      // gameInfoの設定
      this.addGameInfo({ key: 'player1Game', value: this.info.s1 });
      this.addGameInfo({ key: 'player2Game', value: this.info.s2 });
      if (this.user.signIn && this.app.docId) {
        if (isToDataPage) {
          this.storeIsLoading(true);
        }
        this.firstoreUpdate(isDetailData)
          .then(() => {
            if (isToDataPage) {
              this.reset({ isProMode: false });
              this.$router.push('/data_page');
            }
          })
          .catch((error) => {
            this.dbError(error);
          })
          .finally(() => {
            this.storeIsLoading(false);
          });
      } else if (this.user.signIn) {
        if (isToDataPage) {
          this.storeIsLoading(true);
        }
        // 二重保存防止
        this.submittingFlg = true;
        this.firestoreAdd()
          .then(() => {
            this.reset({ isProMode: false });
            this.$router.push('/data_page');
          })
          .catch((error) => {
            this.dbError(error);
          })
          .finally(() => {
            this.submittingFlg = false;
            this.storeIsLoading(false);
          });
      } else {
        alert('ログイン後ご利用ください。');
      }
    },
    deleteData() {
      if (confirm('データを削除します。よろしいですか？')) {
        this.delGameData();
        this.submitData(true, false);
        this.reset({ isProMode: true });
      }
    },
    outputData() {
      alert('PC版ChromeまたはMicrosoft Edgeをお使いください。その他のブラウザでは動作しません。');
      makeCsv.exportCsv(this.game);
    },
    resetConf(isProMode) {
      if (confirm('分析中のデータをリセットしますか？(保存済みのデータは削除されません)')) {
        this.reset({ isProMode });
        // このコンポーネントで追加したDataは全部リセットすること
        this.initHit();
        this.initHits();
        this.clickCount = 0;
      }
    },
    linkShareFlgOnClick() {
      // v-modelでの値の変更よりクリックイベントほうが先に動くらしいので、反転させる
      if (!this.game.gameInfo.publicShareFlg) {
        this.linkShareFlgOn(true);
      }
    },
    publicShareFlgOnClick() {
      if (this.game.gameInfo.linkShareFlg) {
        this.publicShareFlgOn(false);
      }
    },
    nextPoint(idx, point) {
      this.hit.inOut = false;
      this.hit.inOutDetail = idx;
      this.hit.player = point === 1 ? 2 : 1;
      this.hit.isServe = this.clickCount === 3;
      this.pushHit();
      this.addPoint({ point, label: this.rallyCount, hits: this.hits });
      // 初期化
      this.initHits();
      this.clickCount = 0;
      this.initHit();
    },
    nextHit(idx, player) {
      this.hit.inOut = true;
      this.hit.inOutDetail = idx;
      this.hit.player = player;
      this.hit.isServe = this.clickCount === 3;
      // hitsの各配列にpushする
      this.pushHit();
      // サーブのネットインを例外的に処理する
      if (this.clickCount === 3
        && CmnConst.inList[idx] === 'ネットイン') {
        this.clickCount = 0;
      } else {
        this.clickCount += 1;
      }
      this.initHit();
    },
    pushHit() {
      this.hits.player.push(this.hit.player);
      this.hits.hand.push(this.hit.hand);
      this.hits.hitStyle.push(this.hit.hitStyle);
      this.hits.hitPosition.push(this.hit.hitPosition);
      this.hits.course.push(this.hit.course);
      this.hits.inOut.push(this.hit.inOut);
      this.hits.inOutDetail.push(this.hit.inOutDetail);
      this.hits.isServe.push(this.hit.isServe);
    },
    popHits() {
      this.hits.player.pop();
      this.hits.hand.pop();
      this.hits.hitStyle.pop();
      this.hits.hitPosition.pop();
      this.hits.course.pop();
      this.hits.inOut.pop();
      this.hits.inOutDetail.pop();
      this.hits.isServe.pop();
    },
    initHit() {
      this.hit = {
        player: 0, // 1 or 2
        hand: null, // int 0:forehand, 1:backhand
        hitStyle: null, // int
        hitPosition: 0, // 0:前陣, 1:中陣, 2:後陣
        course: null, // int
        inOut: null, // boolean, true: In, false: Out
        inOutDetail: null, // int
        isServe: false, // true, false
      };
    },
    initHits() {
      this.hits = {
        hand: [],
        hitStyle: [],
        hitPosition: [],
        course: [],
        inOut: [],
        inOutDetail: [],
        player: [],
        isServe: [],
      };
    },
    back() {
      // サーブ権選択後すぐの場合
      // サーブ情報の入力時
      // サーブ以降の打球入力時
      if (this.hits.player.length === 0 && this.game.points.length === 0) {
        this.addGameInfo({ key: 'firstGameServer', value: 0 });
        this.clickCount = 0;
      } else if (this.hits.player.length === 0) {
        this.hits = { ...this.game.hitsList[this.game.points.length - 1] };
        if (this.hits.player.length > 0) {
          this.popHits();
        }
        const label = this.game.labels[this.game.labels.length - 1];
        this.delPoint();
        this.initHit();
        this.clickCount = Math.max(label * 4, 0);
        // stateの情報を一つ削除
      } else {
        this.popHits();
        this.clickCount = Math.max(this.clickCount - 4, 0);
      }
    },
    editHits(pointIdx, hitIdx) {
      this.editHit = {
        hand: this.game.hitsList[pointIdx].hand[hitIdx],
        hitStyle: this.game.hitsList[pointIdx].hitStyle[hitIdx],
        hitPosition: this.game.hitsList[pointIdx].hitPosition[hitIdx],
        course: this.game.hitsList[pointIdx].course[hitIdx],
        inOut: this.game.hitsList[pointIdx].inOut[hitIdx],
        inOutDetail: this.game.hitsList[pointIdx].inOutDetail[hitIdx],
        player: this.game.hitsList[pointIdx].player[hitIdx],
        isServe: this.game.hitsList[pointIdx].isServe[hitIdx],
      };
      this.editIdx = { pointIdx, hitIdx };
      this.$bvModal.show('modal-2');
    },
    updHitsOnClick() {
      this.updHits({ hit: this.editHit, ...this.editIdx });
      this.$bvModal.hide('modal-2');
    },
    dbError(error) {
      if (error.code === 'permission-denied') {
        alert('タイムアウトしました。再度ログインしてからやり直してください。');
        this.SignOut();
        this.$router.push('/');
      } else {
        alert('データの保存に失敗しました。しばらくしてから再度やり直してください。');
      }
    },
  },
};
</script>

<style scoped>
#analyze{
  text-align: center;
}

.btn-dblue{
  color: #fff;
  background-color: #66a2cc;
  border-color: #66a2cc;
  width: 100%;
  height: 60px;
}

.btn-dgreen{
  color: #fff;
  background-color: #04B4AE;
  border-color: #04B4AE;
  width: 100%;
  height: 60px;
}

.btn-option{
  width: 100%;
  height: 60px;
}

.pa-2 {
  padding: 2px;
}

.mw-600{
  max-width: 600px;
}

.title-font{
  font-family: 'Orbitron', sans-serif;
}

.slide-fade-enter-active {
  transition: all .1s ease;
}
.slide-fade-leave-active {
  transition: all .1s cubic-bezier(.98,.01,1,1);
}
.slide-fade-leave-to, .slide-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/AnalyzeDetail.vue